<template>
  <div class="d-flex flex-column p-12px rounded border">
    <div class="d-flex align-items-center justify-content-between">
      <div class="font-size-500 text-neutral-300">Cash on Hand</div>
      <b-btn size="sm" variant="primary" @click="$bvModal.show('cash-on-hand-edit')">
        <i class="jala jala-edit"></i>
      </b-btn>
    </div>
    <Loader no-axios :loading="loading">
      <div class="text-xl">{{ $numeral(model.value).format("0,0") }}</div>
      <div class="auditable" v-if="model.updater">
        <div>Diperbarui pada: {{ $moment(model.updated_at).format("DD MMMM YYYY HH:mm:ss") }}</div>
        <div>Oleh: {{ model.updater.name }}</div>
      </div>
    </Loader>
    <cash-on-hand-edit id="cash-on-hand-edit" v-model="model" @updated="fetchModel"></cash-on-hand-edit>
  </div>
</template>

<script>
import Loader from "@/components/widgets/loader";
import CashOnHandEdit from "@/components/modals/cash-on-hand-edit";
export default {
  components: {
    Loader,
    CashOnHandEdit
  },
  props: {},
  data() {
    return {
      model: {
        value: 0
      },
      loading: false
    };
  },
  mounted() {
    this.fetchModel();
  },
  methods: {
    fetchModel() {
      this.loading = true;
      return this.$axios
        .get("constants/cash_on_hand", {
          params: {
            with: "updater"
          }
        })
        .then(response => {
          const { data } = response.data;
          this.model = {
            ...data,
            initial_value: data.value
          };
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.auditable {
  color: #6c7589;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
